import { render } from "./PlansView.vue?vue&type=template&id=a5cf762c"
import script from "./PlansView.vue?vue&type=script&lang=js"
export * from "./PlansView.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2677690992/src/emulator.totogidemos.com/frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__